export default {"src":"/_next/static/media/bussiness.ccff4af3.svg","height":17,"width":16};